import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-top-right',
  templateUrl: './top-right.component.html',
  styleUrls: ['./top-right.component.scss']
})
export class TopRightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
